"use client";

import {useEffect} from "react";
import {useModifierShortcutHint} from "@/hooks/useAssistantShortcutHint";
import {useStableCallback} from "@/hooks/useStableCallback";
import {LAUNCHER_SHORTCUT_KEY} from "@/utils/chat/gailGptLauncher";
import {isModifierShortcut} from "@/utils/common/keyboard";

export function useGailLauncherShortcutHint() {
  const shortcutHint = useModifierShortcutHint(LAUNCHER_SHORTCUT_KEY);
  return {
    shortcutHint,
    ariaKeyShortcuts: shortcutHint ? (shortcutHint.startsWith("⌘") ? "Meta+J" : "Control+J") : undefined,
  };
}

/** One keyboard contract for the side sheet and existing dock. */
export function useGailLauncherShortcut(onActivate: () => void) {
  const activate = useStableCallback(onActivate);
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented || event.repeat || !isModifierShortcut(event, LAUNCHER_SHORTCUT_KEY)) return;
      event.preventDefault();
      activate();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [activate]);
}
